<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="商品ID" prop="productId">
          <el-input v-model="dataForm.productId" placeholder="商品ID"></el-input>
      </el-form-item>
          <el-form-item label="商品名称" prop="productName">
          <el-input v-model="dataForm.productName" placeholder="商品名称"></el-input>
      </el-form-item>
          <el-form-item label="商品规格型号" prop="productAttribute">
          <el-input v-model="dataForm.productAttribute" placeholder="商品规格型号"></el-input>
      </el-form-item>
          <el-form-item label="评价会员ID" prop="memberId">
          <el-input v-model="dataForm.memberId" placeholder="评价会员ID"></el-input>
      </el-form-item>
          <el-form-item label="评价会员名称" prop="memberName">
          <el-input v-model="dataForm.memberName" placeholder="评价会员名称"></el-input>
      </el-form-item>
          <el-form-item label="评论会员头像" prop="memberAvatar">
          <el-input v-model="dataForm.memberAvatar" placeholder="评论会员头像"></el-input>
      </el-form-item>
          <el-form-item label="评价星数：0->5" prop="star">
          <el-input v-model="dataForm.star" placeholder="评价星数：0->5"></el-input>
      </el-form-item>
          <el-form-item label="评价文本内容" prop="content">
          <el-input v-model="dataForm.content" placeholder="评价文本内容"></el-input>
      </el-form-item>
          <el-form-item label="上传图片地址，以逗号隔开" prop="pictures">
          <el-input v-model="dataForm.pictures" placeholder="上传图片地址，以逗号隔开"></el-input>
      </el-form-item>
          <el-form-item label="回复数量" prop="replayCount">
          <el-input v-model="dataForm.replayCount" placeholder="回复数量"></el-input>
      </el-form-item>
          <el-form-item label="阅读数量" prop="collectCouont">
          <el-input v-model="dataForm.collectCouont" placeholder="阅读数量"></el-input>
      </el-form-item>
          <el-form-item label="显示状态(1显示 2不显示)" prop="showStatus">
          <el-input v-model="dataForm.showStatus" placeholder="显示状态(1显示 2不显示)"></el-input>
      </el-form-item>
            <el-form-item label="部门ID" prop="deptId">
          <el-input v-model="dataForm.deptId" placeholder="部门ID"></el-input>
      </el-form-item>
            <el-form-item label="更新时间" prop="updateDate">
          <el-input v-model="dataForm.updateDate" placeholder="更新时间"></el-input>
      </el-form-item>
      </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        productId: '',
        productName: '',
        productAttribute: '',
        memberId: '',
        memberName: '',
        memberAvatar: '',
        star: '',
        content: '',
        pictures: '',
        replayCount: '',
        collectCouont: '',
        showStatus: '',
        creator: '',
        deptId: '',
        createDate: '',
        updateDate: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        productId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        productAttribute: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        memberId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        memberName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        memberAvatar: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        star: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        content: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        pictures: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        replayCount: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        collectCouont: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        showStatus: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deptId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        updateDate: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/pms/comment/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/pms/comment/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
